import { render, staticRenderFns } from "./DaftarClientStatic.vue?vue&type=template&id=4579b5fe"
import script from "./DaftarClientStatic.vue?vue&type=script&lang=js"
export * from "./DaftarClientStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports